import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, ExternalLink } from 'lucide-react';
import './Footer.css';
import { professorData } from '../utils/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col footer-about">
            <div className="footer-logo-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_7acabb85-1ee6-4146-88a1-f42a2bc441a5/artifacts/2o83bxai_JP%20Tamvada%20Logo.png" 
                alt="JP Tamvada Logo" 
                className="footer-logo-image"
              />
              <h3 className="footer-logo">Prof. J.P. Tamvada</h3>
            </div>
            <p className="footer-tagline">
              Strategic Growth Advisor to governments, enterprises, and high-impact ventures worldwide
            </p>
            <div className="footer-social">
              <a
                href={`mailto:${professorData.email}`}
                className="social-link"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
              <a
                href={professorData.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={professorData.orcid}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="ORCID"
              >
                <ExternalLink size={20} />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">Navigation</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/knowledge">Knowledge Centre</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><span>Strategic Growth Advisory</span></li>
              <li><span>Complex Problem Solving</span></li>
              <li><span>Government Advisory</span></li>
              <li><span>Executive Mentorship</span></li>
              <li><span>Venture Strategy</span></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">Get in Touch</h4>
            <p className="footer-text">
              For strategic advisory inquiries and speaking engagements
            </p>
            <Link to="/contact" className="btn btn-outline-light btn-footer">
              Book Strategy Session
            </Link>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} Professor Jagannadha Pawan Tamvada. All rights reserved.
            </p>
            <div className="footer-affiliations">
              <span>Kingston University London</span>
              <span className="separator">•</span>
              <span>Fellow, Royal Society of Arts</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;